const CONST = {
    'SET_CONFIG':'ROSTER_ARCHIVE/SET_CONFIG',
    'SET_SELECTED_ITEM':'ROSTER_ARCHIVE/SET_SELECTED_ITEM',
    'FETCH_ITEM_SUCCESS':'ROSTER_ARCHIVE/FETCH_ITEM_SUCCESS',
    'FETCH_ITEM_FAILED':'ROSTER_ARCHIVE/FETCH_ITEM_FAILED',
    'FETCH_ITEMS_SUCCESS':'ROSTER_ARCHIVE/FETCH_ITEMS_SUCCESS',
    'FETCH_ITEMS_FAILED':'ROSTER_ARCHIVE/FETCH_ITEMS_FAILED',
}

export default CONST;

